import {API_URL, apiPost} from '../api'
import {ICreateFeedTemplate} from '../../pages/feed/types'

// POST /v3/admin/feed_template — 템플릿 등록(생성 시 active). placeholder는 kind 계약으로 검증되며
// 계약 밖 변수는 code 5050으로 거부(error 필드에 위반 변수명).
export const createFeedTemplate = async (body: ICreateFeedTemplate) => {
    return await apiPost(API_URL, 'admin/feed_template', body)
}
